import { createSlice } from '@reduxjs/toolkit';
//const token = storage.get("classToken") || "";
const initialState = {
  classes: [],
};
const slice = createSlice({
  name: 'class',
  initialState,

  reducers: {
    setClass: (state, action) => {
      state.classes = action.payload;
    },

    updateSectionSidebar: (state, action) => {
      const item = action.payload;
      for (let i = 0; i < state.classes.length; i++) {
        const clas = state.classes[i];
        for (let j = 0; j < clas.sections.length; j++) {
          const section = clas.sections[j];
          if (section._id === item._id) {
            state.classes[i].sections[j] = item;
            return;
          }
        }
      }
    },

    deleteSectionsidebar: (state, action) => {
      const { sectionId, classId } = action.payload;

      const classIndex = state.classes.findIndex((clas) => clas._id === classId);

      if (classIndex !== -1) {
        // ✅ Ensure Redux detects the state update
        state.classes = state.classes.map((clas, index) =>
          index === classIndex
            ? {
                ...clas,
                sections: clas.sections.filter((section) => section._id !== sectionId),
              }
            : clas
        );
      }
    },

    // resetClass: (state) => {
    //   state = initialState;
    // },
  },
});

export const { setClass, resetClass, setToken, deleteSectionsidebar, updateSectionSidebar } = slice.actions;
export default slice.reducer;
